import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { SelectionRange } from "../global";
import { getSelectionRangeFactory } from "../handlers/selection";
import { getCsrfHeaderName, getCsrfHeaderValue } from "../ext/htmxAntiCsrf";
import { SelectionRangeFactory } from "../office/SelectionRangeFactory";

type SelectionTestState = "IDLE" | "LOADING" | "RUNNING"

type SelectionTestResult = "FRONTEND_FAILED" | "BACKEND_FAILED" | "SUCCESS"

export default class SelectionTest extends AlpineComponent {
    constructor(
        public postUrl: string,
        public state: SelectionTestState = "IDLE",
        public paragraphIds: string[] = [],
        public requests: (SelectionRange | null)[] = [],
        public results: (SelectionTestResult | null)[] = [],
        public frontendTimes: (number | null)[] = [],
        public backendTimes: (number | null)[] = [],
        public totalFrontend = 0,
        public totalBackend = 0,
        public nFrontend = 0,
        public nBackend = 0,
        public meanFrontendTime = 0,
        public meanBackendTime = 0
    ) {
        super()
    }

    public init() {

    }

    public destroy() {

    }

    public async onClickStop() {
        this.state = "IDLE"
    }

    public async onClickRestart() {
        await this.onClickStart()
    }

    public async onClickStart() {
        this.state = "LOADING"
        this.paragraphIds = []
        this.requests = []
        this.results = []
        this.frontendTimes = []
        this.backendTimes = []
        this.nFrontend = 0
        this.nBackend = 0
        this.totalFrontend = 0
        this.totalBackend = 0
        this.meanFrontendTime = 0
        this.meanBackendTime = 0
        await this.load()

        this.state = "RUNNING"
        await this.runAll()

        this.state = "IDLE"
    }


    public async load() {
        await Word.run(async ctx => {
            const ps = ctx.document.body.paragraphs
            ps.load("items")
            await ctx.sync()

            for (let i = 0; i < ps.items.length; i++) {
                const p = ps.items[i].uniqueLocalId
                this.paragraphIds.push(p)
                this.requests.push(null)
                this.results.push(null)
                this.frontendTimes.push(null)
                this.backendTimes.push(null)
            }
        })
    }

    public async runAll() {
        const factory = getSelectionRangeFactory()
        if (factory === null) {
            console.error("Could not retreive SelectionRangeFactory singleton")
            return
        }
        for (let i = 0; i < this.paragraphIds.length; i++) {
            await this.runOne(factory, i)
            if (this.state === "IDLE") return
        }
    }

    public async runOne(factory: SelectionRangeFactory, idx: number,) {
        const pId = this.paragraphIds[idx]
        const frontendStart = performance.now()

        this.requests[idx] = await Word.run(async ctx => {
            try {
                const p = ctx.document.getParagraphByUniqueLocalId(pId)
                const range = p.getRange("Content")
                range.load()
                await ctx.sync();

                return await factory.fromRange(ctx, range)
            } catch (ex) {
                console.error(ex)
                return null
            }
        })

        if (this.requests[idx] == null) {
            this.results[idx] = "FRONTEND_FAILED"
            return
        }

        const frontendEnd = performance.now()
        const frontendTime = Math.round(frontendEnd - frontendStart)
        this.frontendTimes[idx] = frontendTime
        this.totalFrontend += frontendTime
        this.nFrontend += 1
        this.meanFrontendTime = Math.round(this.totalFrontend / this.nFrontend)

        const backendStart = performance.now()

        const headers: HeadersInit = {}
        headers[getCsrfHeaderName()] = getCsrfHeaderValue()
        headers['Content-Type'] = 'application/json'
        const response = await fetch(this.postUrl, {
            method: "POST",
            headers,
            body: JSON.stringify(this.requests[idx])
        })

        if (response.status === 200) {
            this.results[idx] = "SUCCESS"
        } else {
            this.results[idx] = "BACKEND_FAILED"
        }

        const backendEnd = performance.now()
        const backendTime = Math.round(backendEnd - backendStart)
        this.backendTimes[idx] = backendTime
        this.totalBackend += backendTime
        this.nBackend += 1
        this.meanBackendTime = Math.round(this.totalBackend / this.nBackend)
    }
}
